
import { login, users } from "../../utils/constants";
import { publicRequest } from "../../utils/requestMethods";
 export async  function getUsers() {
    return await publicRequest.get(users);
  }

  export async  function getNotifications() {
    return await publicRequest.get(users);
  }
  export  async  function loginPost(email,password) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  })
  }

  export  async  function addNewUserPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }
  export  async  function editUserPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }

  export  async  function editProfilePost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }
  export  async  function changePasswordPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }